import { FC, ReactNode } from 'react';
import { FormControlLabel, Radio } from '@mui/material';

export interface IRadioButtonProps {
    value: string;
    label?: string;
    labelAsNode?: ReactNode;
    disabled?: boolean;
}

export const RadioButton: FC<IRadioButtonProps> = ({ value, label, labelAsNode, disabled }) => {
    return (
        <FormControlLabel
            key={value}
            value={value}
            control={<Radio disabled={disabled} />}
            label={label || labelAsNode}
        />
    );
};
